import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";
import { Icon } from "./Icon";
import "./sort-header.css";

export type SortDirection = "asc" | "desc";

/** Il valore di `aria-sort` per la `<th>` che contiene il pulsante: va sulla cella, non sul pulsante. */
export function ariaSortOf(direction: SortDirection | null): "ascending" | "descending" | "none" {
  if (direction === "asc") return "ascending";
  if (direction === "desc") return "descending";
  return "none";
}

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  /** Il nome della colonna. */
  label: ReactNode;
  /** L'ordine della colonna, se è quella che ordina; `null` se no (la freccia non c'è). */
  direction: SortDirection | null;
  /** Arriva al `<button>` (in React 19 `ref` è una prop). */
  ref?: Ref<HTMLButtonElement>;
};

// Il pulsante dentro l'intestazione di una colonna che si ordina: un clic cambia l'ordine (lo decide chi lo usa con
// `onClick`). Lo stato lo dice `aria-sort` sulla `<th>` (`ariaSortOf`); la freccia lo mostra ed è decorazione.
export function SortHeader({ label, direction, type = "button", className, ...rest }: Props) {
  return (
    <button type={type} className={className ? `g-sort ${className}` : "g-sort"} data-sorted={direction ?? undefined} {...rest}>
      {label}
      <span className="g-sort__arrow" aria-hidden="true">
        {direction ? <Icon name={direction === "asc" ? "up" : "down"} /> : null}
      </span>
    </button>
  );
}
